import { useEffect, useState } from "react";
import "./CustomerFormStyle.css";
import { CheckOutlined, LoadingOutlined } from "@ant-design/icons";
import _ from "lodash";
import { onecodeAPI } from "../AppConfig";
import { TiTick } from "react-icons/ti";
import { style } from "@mui/system";
import { isCharWithoutSymbol } from "../utils/regexConstants";

export default function CustomInput({
  type = "text",
  label,
  handleChange,
  handleBlur,
  value,
  name,
  readonly,

  setSearchedPincodeList = () => {},
  setSearchedCompanyList = () => {},
}) {
  // Pin Code Search

  const [searchTerm, setSearchTerm] = useState(null);
  const [pincodes, setPincodes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showPincodes, setShowPincodes] = useState(true);
  const [showCompanies, setShowCompanies] = useState(true);
  const [companies, setCompanies] = useState([]);
  const [companyLoading, setCompanyLoading] = useState(false);

  const getCompanyList = async (companyName) => {
    try {
      const res = await onecodeAPI.get(
        `/public/employer/list?name=${companyName}&page=0&size=10`
      );
      // console.log(
      //   "fetchPinCodesList=================",
      //   JSON.stringify(res.data)
      // );
      return res.data;
    } catch (error) {
      // showError();
    }
  };

  const fetchCompanies = async (searchTerm) => {
    try {
      setCompanyLoading(true);
      const res = await getCompanyList(searchTerm);

      setCompanies(
        _.map(res, (item) => {
          return {
            value: item.value,
            label: item.label,
          };
        })
      );

      // console.log(res,"-----fetchCompanies");
      setSearchedCompanyList(res);

      // console.log("fetchPicodes", pincodes);
      // setLoading(false);
      setCompanyLoading(false);
    } catch (error) {
      // setLoading(false);
      console.log(error);
    }
  };

  const fetchPinCodesList = async (pincodeText) => {
    // console.log("pincodeText", pincodeText);
    try {
      setLoading(true);
      const res = await onecodeAPI.get(
        `/public/pincode?pincode=${pincodeText}`
      );
      // console.log("res", res);
      setLoading(false);
      return res.data;
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const fetchPicodes = async (searchTerm) => {
    try {
      // console.log("searchTerm", searchTerm);
      const res = await fetchPinCodesList(searchTerm);

      setPincodes(
        _.map(res?.data?.pincodeMaster, (pincode) => {
          return {
            value: pincode,
            label: pincode,
          };
        })
      );
      setSearchedPincodeList(res?.data?.pincodeMaster);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (searchTerm && name === "pinCode") {
      fetchPicodes(searchTerm);
    }
  }, [searchTerm]);

  useEffect(() => {
    if (searchTerm && name == "employerName" && searchTerm.length > 2)
      fetchCompanies(searchTerm);
  }, [searchTerm]);

  // Handle Search
  const handleSearch = (text) => {
    // console.log("text", text);
    setSearchTerm(text);
  };

  const debouncedSearchHandler = _.debounce(handleSearch, 500);

  return (
    <div
      // onBlur={(e) => {
      //   if (!e.currentTarget.contains(e.relatedTarget)) {
      //       // Not triggered when swapping focus between children
      //       setShowPincodes(false)}
      //   }

      // }
      //  onFocus={() => setShowPincodes(true)}
      className="input-container"
    >
      <input
        type={type}
        value={value}
        placeholder=""
        onChange={(text) => {
          // if (name !== "pinCode")
          if (name === "pinCode" || name == "employerName") {
            if (
              isCharWithoutSymbol.test(text?.target?.value) ||
              text?.target?.value === ""
            ) {
              handleChange(text?.target?.value);
              debouncedSearchHandler(text?.target?.value);
            }
          } else {
            // handleChange(text?.target?.value);
            handleChange(text);
          }
        }}
        onBlur={handleBlur}
        name={name}
        readOnly={readonly}
      />
      {loading && (
        <LoadingOutlined
          style={{
            position: "absolute",
            right: 50,
            top: 20,
            color: "#6C63FF",
            fontSize: "22px",
          }}
          // height={30} width={30}
        />
      )}

      <label
        className={value && "filled"}
        style={{
          transform: name === "dob" && !value && "translate(0, 10px) scale(1)",
        }}
      >
        {label}{" "}
        {name !== "twoWheelerNo" && name !== "fourWheelerNo" && (
          <span
            style={{
              fontSize: "20px",
              color: "#6C63FF",
            }}
          >
            *
          </span>
        )}
      </label>

      {name === "panNo" && (
        <CheckOutlined
          style={{
            color: "#00BA00",
            fontSize: "14px",
            position: "absolute",
            right: 10,
            top: "40%",
            fontWeight: "bolder",
          }}
        />
        // <TiTick
        //   style={{
        //     color: "#00BA00",
        //     fontSize: "20px",
        //     position: "absolute",
        //     right: 10,
        //     top: "30%",
        //   }}
        // />
      )}
      <div
        style={{
          // overflow: "scroll",
          // maxHeight: 400,
          width: "100%",
          zIndex: 2000,
        }}
      >
        {name === "pinCode" &&
          showPincodes &&
          pincodes &&
          pincodes?.slice(0, 10)?.map((ele) => (
            <div
              onClick={() => {
                handleChange(ele.value);
                setPincodes([]);
              }}
              key={ele.label}
              style={{
                // borderWidth: 1,
                paddingTop: 16,
                paddingBottom: 16,
                paddingLeft: 12,
                width: "100%",
                alignSelf: "center",
                backgroundColor: "white",
                zIndex: 3000,
              }}
            >
              <span style={{ color: "grey" }}>{ele.value}</span>
            </div>
          ))}
        {name === "employerName" &&
          showCompanies &&
          companies &&
          companies?.slice(0, 10)?.map((ele) => (
            <div
              onClick={() => {
                handleChange(ele.label);
                setCompanies([]);
              }}
              key={ele.value}
              style={{
                // borderWidth: 1,
                paddingTop: 16,
                paddingBottom: 16,
                paddingLeft: 12,
                width: "100%",
                alignSelf: "center",
                backgroundColor: "white",
                zIndex: 3000,
              }}
            >
              <span style={{ color: "grey" }}>{ele.label}</span>
            </div>
          ))}
      </div>
    </div>
  );
}
